import { styled } from 'styled-components';

export const ListingViewActionButtonsHolder = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  position: relative;
`;
